// extracted by mini-css-extract-plugin
export default {"TabsContainer":"Tabs_TabsContainer__-Z+Gn","TabsScroller":"Tabs_TabsScroller__1dWIc","TabsIndicator":"Tabs_TabsIndicator__8hSjx"};